import styled from 'styled-components';
import { breakpoints } from '@avangard/ui/utils';

import { PageFilters } from '@modules/shared/organisms';
import { useLapsTableFiltersQuery } from '@modules/lap/hooks';
import { ToolbarFilters } from './toolbar-filters';

const Root = styled.div`
    margin-inline-start: auto;
    width: 100%;
    max-width: 220px;
    flex: 0 0 auto;

    ${breakpoints.down(411)} {
        margin-inline-end: auto;
        margin-inline-start: 0;
        margin-top: 14px;
    }
`;

const initialFilters = {
    courseId: '',
};

const LapsListFilter = (): React.ReactElement => {
    const { filters: queryFilters } = useLapsTableFiltersQuery();

    return (
        <Root>
            <PageFilters queryFilters={queryFilters} initials={initialFilters}>
                <ToolbarFilters />
            </PageFilters>
        </Root>
    );
};

export { LapsListFilter };
